import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=df8c5c0e&scoped=true&"
import script from "./Suppliers.vue?vue&type=script&lang=js&"
export * from "./Suppliers.vue?vue&type=script&lang=js&"
import style0 from "./Suppliers.vue?vue&type=style&index=0&id=df8c5c0e&prod&scoped=true&lang=css&"
import style1 from "./Suppliers.vue?vue&type=style&index=1&id=df8c5c0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8c5c0e",
  null
  
)

export default component.exports